function natsort(a, b) {
  if (!a || !b) {
    return 0;
  }
  return a.localeCompare(b, navigator.languages[0] || navigator.language, {numeric: true, ignorePunctuation: true});
}

export default natsort;